var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value === true)?_c('div',[_vm._v("Ano")]):(_vm.value === false)?_c('div',[_vm._v("Ne")]):_c('div',[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }